export default __webpack_public_path__ + "static/media/QSGA_Columns.ef940ed5.png";